import Axios from "axios";
import { API_END_POINT } from "../config";
import { BlockBlobClient } from "@azure/storage-blob";
export const fetchApps = () => {
    //mock
    return {
        data: [
            {
                appId: 1,
                appName: "appcenter",
                os: "Android",
                version: "1.0.0",
                releaseType: 'Production',
                releaseDescription: "Initial production release with core features including user authentication, dashboard, and basic analytics. This version lays the foundation for future updates and ensures stability for end users.",
                releaseDate: (() => { const d = new Date("2024-06-01"); d.setHours(0, 0, 0, 0); return d; })()
            }, {
                appId: 1,
                appName: "appcenter",
                os: "Android",
                version: "1.0.1",
                releaseType: 'Production',
                releaseDescription: "Initial production release with core features including user authentication, dashboard, and basic analytics. This version lays the foundation for future updates and ensures stability for end users.",
                releaseDate: new Date("2024-06-01").setHours(0, 0, 0, 0)
            }, {
                appId: 1,
                appName: "appcenter",
                os: "Android",
                version: "1.0.0",
                releaseType: 'Production',
                releaseDescription: "Initial production release with core features including user authentication, dashboard, and basic analytics. This version lays the foundation for future updates and ensures stability for end users.",
                releaseDate: new Date("2024-06-01").setHours(0, 0, 0, 0)
            },
            {
                appId: 2,
                appName: "MSP",
                os: "Android",
                version: "1.0.1",
                releaseType: 'Staging',
                releaseDescription: "Bug fixes and improvements for MSP. Addressed minor issues, improved performance, and enhanced UI.",
                releaseDate: (() => { const d = new Date("2024-06-05"); d.setHours(0, 0, 0, 0); return d; })()
            },
            {
                appId: 3,
                appName: "CCP",
                os: "Android",
                version: "1.0.2",
                releaseType: 'Production',
                releaseDescription: "Performance enhancements for CCP. Optimized queries, reduced startup time, and added language support.",
                releaseDate: (() => { const d = new Date("2024-06-10"); d.setHours(0, 0, 0, 0); return d; })()
            },
            {
                appId: 4,
                appName: "Whatsapp",
                os: "Android",
                version: "1.0.3",
                releaseType: 'Staging',
                releaseDescription: "Beta features added to Whatsapp. Introduced experimental modules and improved logging for QA.",
                releaseDate: (() => { const d = new Date("2024-06-15"); d.setHours(0, 0, 0, 0); return d; })()
            }
        ]
    }
}

export const fetchApplications = async (appId: number) => {
    // mock

    try {
        const response = await Axios.get(
            `${API_END_POINT.BASE_URL.APP_CENTER}/api/apps/version/${appId}`);
        return response.data.content;
    } catch (error) {
        return {
            data: [],
            error: "Network error or server unavailable"
        };
    }
    // const allApps = [
    //     {
    //         appId: 1,
    //         appName: "appcenter",
    //         os: "Android",
    //         version: "1.0.0",
    //         releaseType: 'Production',
    //         releaseDescription: "Initial production release with core features including user authentication, dashboard, and basic analytics. This version lays the foundation for future updates and ensures stability for end users.",
    //         releaseDate: (() => { const d = new Date("2024-06-01"); d.setHours(0, 0, 0, 0); return d; })()
    //     }, {
    //         appId: 1,
    //         appName: "appcenter",
    //         os: "Android",
    //         version: "1.0.1",
    //         releaseType: 'Production',
    //         releaseDescription: "Initial production release with core features including user authentication, dashboard, and basic analytics. This version lays the foundation for future updates and ensures stability for end users.",
    //         releaseDate: new Date("2024-06-01").setHours(0, 0, 0, 0)
    //     }, {
    //         appId: 1,
    //         appName: "appcenter",
    //         os: "Android",
    //         version: "1.0.0",
    //         releaseType: 'Production',
    //         releaseDescription: "Initial production release with core features including user authentication, dashboard, and basic analytics. This version lays the foundation for future updates and ensures stability for end users.",
    //         releaseDate: new Date("2024-06-01").setHours(0, 0, 0, 0)
    //     },
    //     {
    //         appId: 2,
    //         appName: "MSP",
    //         os: "Android",
    //         version: "1.0.1",
    //         releaseType: 'Staging',
    //         releaseDescription: "Bug fixes and improvements for MSP. Addressed minor issues, improved performance, and enhanced UI.",
    //         releaseDate: (() => { const d = new Date("2024-06-05"); d.setHours(0, 0, 0, 0); return d; })()
    //     },
    //     {
    //         appId: 3,
    //         appName: "CCP",
    //         os: "Android",
    //         version: "1.0.2",
    //         releaseType: 'Production',
    //         releaseDescription: "Performance enhancements for CCP. Optimized queries, reduced startup time, and added language support.",
    //         releaseDate: (() => { const d = new Date("2024-06-10"); d.setHours(0, 0, 0, 0); return d; })()
    //     },
    //     {
    //         appId: 4,
    //         appName: "Whatsapp",
    //         os: "Android",
    //         version: "1.0.3",
    //         releaseType: 'Staging',
    //         releaseDescription: "Beta features added to Whatsapp. Introduced experimental modules and improved logging for QA.",
    //         releaseDate: (() => { const d = new Date("2024-06-15"); d.setHours(0, 0, 0, 0); return d; })()
    //     }
    // ];
    // return {
    //     data: allApps.filter(app => app.appId === appId)
    // }
}
export const fetchModules = async () => {
    try {
        const response = await Axios.get(`${API_END_POINT.BASE_URL.APP_CENTER}/api/apps`);
        return response.data;
    } catch (error) {
        return {
            content: [],
            error: "Network error or server unavailable"
        };
    }

    // return {
    //     content: [
    //         {
    //             appId: 1,
    //             appName: "appcenter"
    //         },
    //         {
    //             appId: 2,
    //             appName: "MSP"
    //         },
    //         {
    //             appId: 3,
    //             appName: "CCP"
    //         },
    //         {
    //             appId: 4,
    //             appName: "Whatsapp"
    //         }
    //     ]
    // }
}
export const checkAdmin = async (email: string) => {
    try {
        const lowerCaseEmail = email.toLowerCase();
        const response = await Axios.get(`${API_END_POINT.BASE_URL.APP_CENTER}/api/users?email=${lowerCaseEmail}`);
        // Assuming the API returns a user object as shown in your example
        // Check if the user has the ADMIN role
        const isAdmin = response.data?.roleName === "ADMIN";
        return {
            data: {
                isAdmin
            }
        };
    } catch (error) {
        // Handle network or server errors gracefully
        return {
            data: {
                isAdmin: false,
                error: "Network error or server unavailable"
            }
        };
    }
    // return {
    //     data: {
    //         isAdmin: email === 'ravi.k.punnam.consultant@nielseniq.com' // Mock admin check
    //     }
    // }
}
export const uploadAppVersion = async (postObject: any, emailId: string) => {
    try {
        const response = await Axios.post(
            `${API_END_POINT.BASE_URL.APP_CENTER}/api/apps/version/upload`,
            postObject,
            {
                headers: {
                    emailId
                }
            }
        );
        return response.data;
    } catch (error) {
        return {
            error: "Network error or server unavailable"
        };
    }
};

export const fetchAppDownloadDetails = async (appId: any, filename: any) => {
    try {
        const response = await Axios.get(
            `${API_END_POINT.BASE_URL.APP_CENTER}/api/apps/version/blob/token/${appId}?filename=${filename}`
        );      

       return response.data; 

    } catch (error) {
        return {
            error: "Network error or server unavailable"
        };
    }
};

export const fetchBlobToken = async (appId: any, filename: any, file?: File | Blob) => {
    try {
        const response = await Axios.get(
            `${API_END_POINT.BASE_URL.APP_CENTER}/api/apps/version/blob/token/${appId}?filename=${filename}`
        );      

        const blobUrl = response.data; // Use API response or mock

        const uploadToBlob = async (blobUrl: string, file: File | Blob) => {
            const blockBlobClient = new BlockBlobClient(blobUrl);
            await blockBlobClient.uploadData(file, {
                blobHTTPHeaders: { blobContentType: file.type }
            });
            return { success: true, url: blobUrl };
        };

        if (file) {
            return await uploadToBlob(blobUrl, file);
        }

        return { url: blobUrl };
    } catch (error) {
        return {
            error: "Network error or server unavailable"
        };
    }
};


